<script>
import { mapGetters } from 'vuex'
import { productsMethods } from '@state/helpers'
import { StreamBarcodeReader } from 'vue-barcode-reader'

export default {
  name: 'QrSearch',
  components: { StreamBarcodeReader },
  data() {
    return {
      modalShow: false,
      camera_scan: false,
      show_serial_result: false,
    }
  },
  methods: {
    ...productsMethods,
    onDecode(text) {
      this.enableQrScaning()
      if (text.length > 20) this.setQrSerial(text.split(',')[0])
      else this.setQrSerial(text)
      this.modalShow = false
      this.show_serial_result = true
      this.$generate_toast(this, 'success', `Serial leído del QR: ${ this.qr_serial }`)
      this.disableQrScaning()
    },
    onLoaded() {
      this.camera_scan = true
    },
    cleanSearch() {
      this.show_serial_result = false
      this.setQrSerial(null)
    },
  },
  computed: {
    ...mapGetters({
      qr_scaning: 'retina/products/qr_scaning',
      qr_serial: 'retina/products/qr_serial',
    }),
  },
}
</script>
<template>
  <div>
    <!-- COMPONENTE INPUT SERIAL (serialSearch) -->
    <!-- <div class="row">
      <div class="col">

        <b-row align-h="between" class="mb-2">
          <b-col>
            <b-form-group label="Serial" label-cols-xl="2">
              <b-input-group>
                <b-form-input></b-form-input>
                <b-input-group-append>
                  <b-button variant="outline-info">
                    <b-spinner small></b-spinner>
                    <i class="fas fa-search"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

      </div>
      <div class="col-xl-auto"> -->
    <b-button v-b-tooltip.hover="{ variant: 'info', title:'Buscar por QR'}" @click="modalShow = !modalShow" variant="info" >
      <i class="fas fa-qrcode"></i>
      QR
      <b-spinner small v-if="qr_scaning" label="Cargando..."></b-spinner>
    </b-button>
    <!-- </div>
    </div> -->

    <b-alert
      class="mt-2"
      fade
      dismissible
      variant="info"
      :show="show_serial_result"
      @dismissed="cleanSearch()"
    >
      Serial leído del QR: {{ qr_serial }}
    </b-alert>

    <b-modal
      v-model="modalShow"
      @hide="camera_scan = false"
      ok-only
    >
      <template #modal-title>
        <i class="fas fa-qrcode"></i> Búsqueda por QR
      </template>
      <!-- <h4>Lector código QR</h4> -->
      Estado cámara
      <b-badge v-if="camera_scan" variant="success">Lista</b-badge>
      <div v-else>
        <b-spinner
          variant="info"
          small
          type="grow"
          label="Cargando..."
        ></b-spinner>
        Preparando Cámara
      </div>
      <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded" />
    </b-modal>
  </div>
</template>
